<template lang="html">
  <div>
    <ul class="-mb-px border-b border-gray-500 bg-gray-200 flex pt-3">
      <li
        v-for="(tab, index) in tabs"
        :key="tab.title"
        class="tab"
        :class="{ 'tab-active': index == selectedIndex }"
        @click="selectTab(index)"
      >
        {{ tab.title }}
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      selectedIndex: 0, // the index of the selected tab,
      tabs: [] // all of the tabs
    };
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.selectTab(0);
  },
  methods: {
    selectTab(i) {
      this.selectedIndex = i;

      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
      });
    }
  }
};
</script>

<style scoped>
.tab {
  @apply cursor-pointer whitespace-no-wrap px-3 pb-2 border-b-2 border-transparent font-medium text-base leading-5 text-gray-500;
}

.tab:hover {
  @apply text-gray-600;
}

.tab:focus {
  @apply outline-none text-gray-700 border-gray-300;
}

.tab-active {
  @apply border-green-500 text-green-600;
}

.tab-active:hover {
  @apply text-green-800;
}

.tab-active:focus {
  @apply outline-none text-green-800 border-green-700;
}
</style>
